<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="subBlockContent">
  <child-header [title]="title"  (closeEvent)="close()" ></child-header>
  <div class="child-body">
    <div class="inner-subBlock-wrapper">
      <div id="newsLetterEdit-view" *ngIf="newsletterEditViewModel">
        <div class="subBlockContent">
          <div id="newsletterItems">
            <div class="wrapper">
              <div class="content content-white color-dark">
                <div id="newsletterEditor" class="{{newsletterEditViewModel?.color}}">
                  <div id="cmsNewsletterHeader">
                    <div class="top-bottom-space">
                    </div>
                    <div id="cmsNewsletter" class="row no-gutters">
                                    
                      <div class="col-3">
                        Brand &nbsp;
                        <select id="Brand" name="Brand"  (change)="updateHeader($event, 'brand')">
                          <option *ngFor="let brand of brandList" [value]="brand.value"
                            [selected]="newsletterEditViewModel?.brand == brand.value">{{brand.text}}</option>
                        </select>
                      </div>

                      <div class="col-5">
                        Description &nbsp;       
                        <input id="Description" style="width:75%;text-transform: uppercase;" maxlength="80" [(ngModel)]="description"                       
                          [value]="description" (blur)="updateHeader($event, 'description')"
                          (keyup)="checkDescription(description)">
                      </div>

                      <div class="col-4">
                        Colour Scheme &nbsp;
                        <select id="ColorScheme" name="ColorScheme"  (change)="updateHeader($event, 'color')">
                          <option *ngFor="let color of colorList" [value]="color.value"
                            [style.background]="safeStyle(color.style)"
                            [selected]="newsletterEditViewModel?.color == color.value">
                            {{color.style.replace("#","")}}</option>
                        </select>
                      </div>

                      <div class="col-3">
                      Category &nbsp;
                      <select id="Category" name="Category" (change)="updateHeader($event, 'category')">
                        <option *ngFor="let category of categoryList" [value]="category.value"
                        [selected]="newsletterEditViewModel?.category == category.value">{{category.text}}</option>
                      </select>
                    </div>

                      <div class="col-4">
                        License &nbsp;
                        <select id="License" name="License" (change)="updateHeader($event, 'license')">
                          <option *ngFor="let license of licenseList" [value]="license.value"
                          [selected]="newsletterEditViewModel?.license == license.value">{{license.text}}</option>
                        </select>
                      </div>
                  
                      <div class="col-5"></div>

                    </div>

                    <div id="{{newsId}}" class="cms-head cms-editable-area" style="clear:both">
                      <h1 id="NewsletterTitle" class="cms-editable-element" (click)="saveHeader('title')">{{nl_title}}
                      </h1>
                    </div>
                  </div>
                </div>

                <app-newsletter-promo-v2 [newsletterEditViewModel]="newsletterEditViewModel" [sendNewIdToPromo]="newsId"
                  (editPromoEvent)="receiveEditPromoEvent($event)">
                </app-newsletter-promo-v2>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
